import c from "./lib/createApi";

/**
 * 문헌 수집(lit) API — 웹은 JWT 로 /v1/lit/** 을 호출한다.
 * (팀 PC 스크립트는 개인 토큰으로 /v1/lit-api/** 을 쓴다 — 화면에서는 쓰지 않음)
 * 응답 data 의 모양은 docs/thermax-literature-structure.md §3 (snake_case).
 */
export default {
  groups: c("GET", "/v1/lit/groups", true),                 // [lit 0] 분야 코드 목록
  check: c("POST", "/v1/lit/check", true),                  // [lit 1] DOI 중복 확인
  register: c("POST", "/v1/lit/papers", true),              // [lit 2] 등록
  papers: c("GET", "/v1/lit/papers", true),                 // [lit 3] 목록 + 집계
  paper: c("GET", "/v1/lit/papers/:id", true),              // [lit 4] 상세 헤더
  patchPaper: c("PATCH", "/v1/lit/papers/:id", true),       // [lit 5] 분야·상태 수정
  deletePaper: c("DELETE", "/v1/lit/papers/:id", true),     // [lit 6] 삭제
  me: c("GET", "/v1/lit/me", true),                         // [lit 7] 연결 점검
  tokens: {
    list: c("GET", "/v1/lit/tokens", true),                 // [lit-token 1]
    create: c("POST", "/v1/lit/tokens", true),              // [lit-token 2] 원문 1회 반환
    revoke: c("DELETE", "/v1/lit/tokens/:id", true),        // [lit-token 3]
  },
  // (L2) 추출 데이터
  uploads: c("GET", "/v1/lit/papers/:id/uploads", true),    // 버전 목록
  rows: c("GET", "/v1/lit/uploads/:id/rows", true),         // 행 조회 (page, pageSize, property, needsReview)
  deleteUpload: c("DELETE", "/v1/lit/uploads/:id", true),   // 버전 삭제
  // (L3) 원문 md
  fulltexts: c("GET", "/v1/lit/papers/:id/fulltexts", true),// 버전 메타 목록
  fulltext: c("GET", "/v1/lit/fulltexts/:id", true),        // 본문
  patchFulltext: c("PATCH", "/v1/lit/fulltexts/:id", true), // 열람 범위
  deleteFulltext: c("DELETE", "/v1/lit/fulltexts/:id", true),
  // (L4) 보기 UI
  stats: c("GET", "/v1/lit/stats", true),                   // 현황
  rowsSearch: c("GET", "/v1/lit/rows/search", true),        // 통합 행 검색
  aggregate: c("GET", "/v1/lit/rows/aggregate", true),      // histogram / scatter / count
  exploreOptions: c("GET", "/v1/lit/explore/options", true),
};
